//
// OK Box
//
// Simple OK popup, based on skinned box

okBox = {};

okBox.create = function (json) {
  okBox.container = new PIXI.Container();
  return okBox.container;
};

okBox.initialise = function (json, object) {
  if (typeof json.fontDefinition === "undefined") {
    console.log("A font definition was not found for okBox.");
  }

  okBox.background = resourceManager.createObject(
    "skinnedBox",
    "background",
    json.FQN,
    {
      textureName: json.textureName,
      width: json.width,
      height: json.height,
      cornerWidth: json.cornerWidth,
      cornerHeight: json.cornerHeight,
    }
  );
  okBox.container.visible = false;

  // Add a button to skinned box
  var button;
  if (checkForDefined(json.simpleButtonName)) {
    // Simple button
    var buttonParams = {
      fileName: json.simpleButtonName,
      x: json.width / 2,
      y: json.height - json.cornerHeight - 16,
      anchor: 0.5,
      maxWidth: json.buttonTextMaxWidth,
      animLength: json.animLength,
      pressedScale: json.pressedScale,
    };
    if (checkForDefined(json.buttonText)) {
      if (checkForDefined(json.buttonFontDefinition)) {
        buttonParams.fontDefinition = json.buttonFontDefinition;
      } else {
        buttonParams.fontDefinition = json.fontDefinition;
      }

      buttonParams.translationPhrase = json.buttonText;
    }
    button = resourceManager.createObject(
      "simpleButton",
      "button",
      json.FQN,
      buttonParams
    );
  } else {
    // Standard button
    button = resourceManager.createObject("button", "button", json.FQN, {
      center: true,
      text: "OK",
      fontDefinition: json.fontDefinition,
      fileName: json.buttonName,
      x: json.width / 2,
      y: json.height - json.cornerHeight - 16,
      anchor: 0.5,
    });
  }
  button.enableButton(true);
  button.onPressedCallback = function () {
    okBox.container.visible = false;
    messageBus.post("game:modal", {});
    if (typeof okBox.callback !== "undefined") {
      okBox.callback();
    }
  };

  okBox.infoText = resourceManager.createObject("text", "text", json.FQN, {
    x: json.width / 2,
    y: json.height / 3,
    fontDefinition: json.fontDefinition,
    maxWidth: json.maxWidth,
  });
  okBox.infoText.anchor.set(0.5);
};

okBox.getFilesRequired = function (json) {
  var files;
  if (checkForDefined(json.simpleButtonName)) {
    // Simple button
    files = standardObjectFactory.getSimpleButtonFiles({
      fileName: json.simpleButtonName,
    });
  } else {
    // Standard button
    files = standardObjectFactory.getButtonFiles({ fileName: json.buttonName });
  }
  files.push(ReflexLoader.rootResDir + json.textureName);
  return files;
};

okBox.showPopup = function (translationPhrase, closedCallback) {
  okBox.infoText.setTranslationPhrase(translationPhrase);
  okBox.callback = closedCallback;

  okBox.container.visible = true;

  messageBus.post("game:modal", { reason: "Ok popup open" });
};

okBox.onModal = function (msg) {
  // if something takes us out of modal but we are still visible, keep modal
  // For example, history will cause Gati wrapper to pause our game and resume when history closed.
  // Resume will clear modal but this settings menu is still open allowing the player to spin behind the settings menu
  if (okBox.container.visible && msg.reason === undefined) {
    messageBus.post("game:modal", { reason: "OK popup open" });
  }
};

messageBus.subscribe("game:modal", okBox.onModal);

resourceManager.registerObjectType(
  "okBox",
  okBox.create,
  okBox.initialise,
  okBox.getFilesRequired
);
